<template>
<div>
    <!-- modal -->
    <b-modal id="lawMatterEvidenceFormModal" ref="lawMatterEvidenceFormModal" centered size="lg" no-close-on-backdrop :title=" $t('lawMatterEvidence.info')" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <b-row style="margin-right: auto;">
            <b-col>
                <b-row style="width: 160%">
                    <b-col>
                        <b-img :src="imageEmpty" fluid v-bind="mainProps" alt="Img" onclick="document.getElementById('designProductFileSelect').click()" class="ml-2" style="width: 4em; height: 4em;" />
                    </b-col>
                    <hr class="vr" />
                    <b-col>
                        <b-row style="max-width: 15em">
                            <div v-for="image in imageUp" :key="image.id">
                                <feather-icon v-if="imageUp" type="button" style="color:red; margin-top:0.5em" icon="XIcon" @click="deleteImage(image)" />
                                <br />
                                <b-img :src="image" fluid v-bind="mainProps" alt="Img" onclick="document.getElementById('designProductFileSelect').click()" class="ml-2" style="width: 4em; height: 4em;" />
                            </div>
                        </b-row>
                    </b-col>
                </b-row>
            </b-col>
            <b-col>
                <input hidden id="designProductFileSelect" type="file" ref="file" multiple="multiple" @change="uploadImage($event)" accept="image/*" />
            </b-col>
        </b-row>
        <b-row>
            <b-col class="col-lg-6">
                <label for="law-matter-evidence-is-original-product-input">{{ $t('lawMatterEvidence.is_original_product') }}</label>
                <b-form-checkbox class="custom-control-success" name="law-matter-evidence-is-original-product-input" id="law-matter-evidence-is-original-product-input" v-model="isOriginalProduct" switch>
                    <span class="switch-icon-left">
                        <feather-icon icon="CheckIcon" />
                    </span>
                    <span class="switch-icon-right">
                        <feather-icon icon="XIcon" />
                    </span>
                </b-form-checkbox>
            </b-col>
            <b-col class="col-lg-6">
                <label for="law-matter-evidence-is-imitation-product-input">{{ $t('lawMatterEvidence.is_imitation_product') }}</label>
                <b-form-checkbox class="custom-control-success" name="law-matter-evidence-is-imitation-product-input" id="law-matter-evidence-is-imitation-product-input" v-model="isImitationProduct" switch>
                    <span class="switch-icon-left">
                        <feather-icon icon="CheckIcon" />
                    </span>
                    <span class="switch-icon-right">
                        <feather-icon icon="XIcon" />
                    </span>
                </b-form-checkbox>
            </b-col>
        </b-row>
        <b-row class="mt-1">
            <b-col class="col-lg-4">
                <b-form>
                    <label for="law-matter-evidence-purchase-date-input">{{ $t('lawMatterEvidence.purchase_date') }}</label>
                    <b-form-group>
                        <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" :placeholder="$t('lawMatterEvidence.purchase_date')" size="sm" v-model="purchaseDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                    </b-form-group>
                </b-form>
            </b-col>
            <b-col class="col-lg-4">
                <b-form>
                    <label for="law-matter-evidence-finalization-date-input">{{ $t('lawMatterEvidence.arrival_date_from_client') }}</label>
                    <b-form-group>
                        <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" :placeholder="$t('lawMatterEvidence.arrival_date_from_client')" size="sm" v-model="arrivalDateFromClient" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                    </b-form-group>
                </b-form>
            </b-col>

            <b-col class="col-lg-4">
                <b-form>
                    <label for="law-matter-evidence-appeal-date-input">{{ $t('lawMatterEvidence.arrival_date_from_cerberus') }}</label>
                    <b-form-group>
                        <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" :placeholder="$t('lawMatterEvidence.arrival_date_from_cerberus')" size="sm" v-model="arrivalDateFromCerberus" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                    </b-form-group>
                </b-form>
            </b-col>
        </b-row>

        <b-row>
            <b-col class="col-lg-12">
                <label for="law-matter-evidence-note-input">{{ $t('lawMatterEvidence.note') }}</label>
                <b-form-textarea size="sm" id="matter-note-input" v-model="note" max-rows="3" maxlength="250" />
            </b-col>
        </b-row>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getLawMatterEvidenceList: {
            type: Function
        }
    },
    data() {
        return {
            id: 0,
            lawMatterId: 0,
            arrivalDateFromCerberus: null,
            arrivalDateFromClient: null,
            isImitationProduct: false,
            isOriginalProduct: false,
            note: "",
            purchaseDate: null,
            image: null,
            imageList: [],
            imageUp: [],
            imageShow: [],
            imageEmpty: require('@/assets/images/select-icon.jpeg'),
            mainProps: {
                blank: false,
                blankColor: '#777',
                width: 75,
                height: 75,
                class: 'm1',
            },
            imageDeleteShow: []

        }
    },
    methods: {
        clear() {
            this.image = null
        },
        // uploadImage(event) {
        //     var input = event.target;
        //     if (this.id != 0) {
        //         if (input.files && input.files[0]) {
        //             var reader = new FileReader();
        //             reader.onload = (e) => {
        //                 this.image = e.target.result;
        //                 var base64 = this.image.replace(/^data:image\/(png|jpg|jpeg);base64,/, '')
        //                 const data = { fileName: this.id, base64: base64}
        //                 const controller = { name: 'LawMatterEvidence', actionName: 'SaveLawMatterEvidenceLogo'};
        //                 const payload = { data: data, controller: controller};
        //                 this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
        //                     if (response.data.resultStatus == true) {
        //                         this.getLawMatterEvidenceList()
        //                         this.$PleaseClickSave()
        //                     }
        //                 })
        //             }
        //             reader.readAsDataURL(input.files[0]);
        //         }
        //     } else if (this.id == 0) {
        //         if (input.files && input.files[0]) {
        //             var reader = new FileReader();
        //             reader.onload = (e) => {
        //                 this.image = e.target.result;
        //             };
        //             reader.readAsDataURL(input.files[0]);
        //         }
        //     }
        // },
        async uploadImage(event) {
            debugger;
            this.imageList = []
            var input = event.target;
            if (input.files) {
                var filelist = input.files;
                for (var i = 0; i < filelist.length; i++) {
                    var fileInfo = await this.$getFileInfo(filelist[i])
                    this.imageList.push(fileInfo);
                    var fileInfoBase64 = 'data:image/png;base64,' + fileInfo.base64
                    this.imageUp.push(fileInfoBase64)
                }
            }
        },
        deleteImage(image) {
            for (var i = 0; i < this.imageList.length; i++) {
                this.imageDeleteShow.push('data:image/png;base64,' + this.imageList[i].base64)
                if (image == 'data:image/png;base64,' + this.imageList[i].base64) {
                    this.imageList.splice(this.imageList[i], 1)
                }
                const index = this.imageUp.indexOf(image);
                if (index > -1) {
                    var deletedImageUp = this.imageUp.splice(index, 1)
                }
                this.imageUp.splice(deletedImageUp, -1)
            }
        },
        showInfo(id, lawMatterId) {
            this.$refs['lawMatterEvidenceFormModal'].show()
            this.id = id
            this.lawMatterId = lawMatterId
            const data = {
                id: this.id
            }
            const controller = {
                name: 'LawMatterEvidence'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.arrivalDateFromCerberus = response.data.lawMatterEvidence.arrivalDateFromCerberus
                    this.arrivalDateFromClient = response.data.lawMatterEvidence.arrivalDateFromClient
                    this.purchaseDate = response.data.lawMatterEvidence.purchaseDate
                    this.isImitationProduct = response.data.lawMatterEvidence.isImitationProduct
                    this.isOriginalProduct = response.data.lawMatterEvidence.isOriginalProduct
                    this.note = response.data.lawMatterEvidence.note
                    // var nonBase64Image = 'data:image/jpeg;base64,'.concat(response.data.lawMatterEvidence.picture)
                    // this.image = nonBase64Image
                    this.imageList = response.data.lawMatterEvidence.images
                    this.imageUp = []
                    this.imageEmpty = require('@/assets/images/select-icon.jpeg')
                    if (this.imageList != null) {
                        for (var i = 0; i < this.imageList.length; i++) {
                            this.imageShow = this.imageList[i]
                            this.imageUp.push('data:image/png;base64,' + this.imageShow.base64)
                        }
                    }
                } else {
                    this.$bvModal.hide('lawMatterEvidenceFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                    this.clear()
                }
            })
        },
        addOrUpdate() {
            debugger;
            var imageData = [];
            if (this.imageList != null) {
                for (var i = 0; i < this.imageList.length; i++) {
                    const image = {
                        fileName: this.imageList[i].name+ '.' + this.imageList[i].contentType,
                        base64: this.imageList[i].base64
                    }
                    imageData.push(image)
                }
            }
            const data = {
                id: this.id,
                lawMatterId: this.lawMatterId,
                arrivalDateFromCerberus: this.arrivalDateFromCerberus,
                arrivalDateFromClient: this.arrivalDateFromClient,
                isImitationProduct: this.isImitationProduct,
                isOriginalProduct: this.isOriginalProduct,
                note: this.note,
                purchaseDate: this.purchaseDate,
                images: imageData
            }
            const controller = {
                name: 'LawMatterEvidence'
            }
            const payload = {
                data: data,
                controller: controller
            }
            let loader = this.$loading.show()
            this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$bvModal.hide('lawMatterEvidenceFormModal')
                    this.getLawMatterEvidenceList()
                    this.$SaveAlert()
                    this.clear()
                    loader.hide()
                    var base64 = this.image.replace(/^data:image\/(png|jpg|jpeg);base64,/, '')
                    const data = {
                        fileName: this.id,
                        base64: base64
                    }
                    const controller = {
                        name: 'LawMatterEvidence',
                        actionName: 'SaveLawMatterEvidenceLogo'
                    }
                    const payload = {
                        data: data,
                        controller: controller
                    }
                    this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.getLawMatterEvidenceList()
                        } else {
                            this.$CustomWarningAlert(response.data.resultMessage)
                        }
                    })
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                    this.clear()
                }
            })
        },
        clear() {
            this.arrivalDateFromCerberus = null,
                this.arrivalDateFromClient = null,
                this.isImitationProduct = false,
                this.isOriginalProduct = false,
                this.note = "",
                this.purchaseDate = null
        }
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}

.uploading-image {
    display: flex;
    width: 15em;
    height: 10em;
}
</style>
